import { ReactNode, useEffect, useState } from 'react';

import { Select, StyledOption } from './styles';

const { Option } = Select;

type optionType = {
  value: any;
  label?: ReactNode | string;
  [attr: string]: any;
};

interface IAutoComplete {
  options: {
    value: any;
    label: string;
  }[];
  value?: any;
  onChange?: (selected: any) => void;
  onSelected?: (selected: any) => void;
  onClear?: () => void;
  children?: ReactNode;
  [attr: string]: any;
}

const AutoComplete = ({
  options,
  value: parentValue,
  onChange,
  onSelected,
  onClear,
  children,
  ...props
}: IAutoComplete) => {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState();

  const openSelect = () => {
    if (!isOpen) setIsOpen(true);
  };

  const closeSelect = () => {
    if (isOpen) setIsOpen(false);
  };

  const handleFilter = (inputValue: string, option?: optionType) => {
    return option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
  };

  const handleSelect = (_, option: optionType) => {
    closeSelect();

    if (onSelected) {
      onSelected(option.value);
    }
  };

  const handleChange = (valueData) => {
    if (onChange) {
      onChange(valueData);
    } else {
      setValue(valueData);
    }

    if (!valueData) {
      if (onClear) onClear();
    }
  };

  useEffect(() => {
    if (onChange) {
      setValue(parentValue);
    }
  }, [parentValue, onChange]);

  if (children) {
    return (
      <Select
        open={isOpen}
        value={value}
        filterOption={handleFilter}
        onChange={handleChange}
        onSelect={handleSelect}
        onClick={openSelect}
        onFocus={openSelect}
        onSearch={openSelect}
        onBlur={closeSelect}
        size='middle'
        showSearch
        allowClear
        {...props}
      >
        {children ? children : null}
      </Select>
    );
  }

  return (
    <Select
      open={isOpen}
      value={value}
      filterOption={handleFilter}
      onChange={handleChange}
      onSelect={handleSelect}
      onClick={openSelect}
      onFocus={openSelect}
      onSearch={openSelect}
      onBlur={closeSelect}
      size='middle'
      showSearch
      allowClear
      {...props}
    >
      {options.map((option, index) => (
        <Option key={index} value={option.value} label={option.label}>
          <StyledOption>{option.label}</StyledOption>
        </Option>
      ))}
    </Select>
  );
};

export { Option };

export default AutoComplete;
